<template>
  <div>
    <title-bar-back :title="'消费者告知书'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="ifrem_pos">
      <iframe
        :src="$G('https://www.myaz.com/consumer/notification')"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then((m) => m.default || m);
export default {
  name: "Order1",
  components: {
    TitleBarBack,
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.ifrem_pos {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
</style>
